<template>
  <section class="section--benefits">
    <div class="section__container">
      <!-- ROW 1 -->
      <v-row class="section__row">
        <v-col class="section__col" cols="12" sm="6" md="6" lg="4" xl="4">
          <keep-alive>
            <v-img
              eager
              :src="require('@/assets/img/deliver-result.svg')"
              class="section__img"
            ></v-img>
          </keep-alive>
        </v-col>
        <v-col
          class="section__col info__col"
          cols="12"
          sm="6"
          md="6"
          lg="8"
          xl="8"
        >
          <div class="col__info">
            <p class="section__title-2 dms600">We Deliver Results</p>
            <p class="section__description-2 m500">
              DIGU provides top-tier talent in Development, QA, Project Management, and UX/UI Design. Our rigorously vetted experts integrate seamlessly with your team to deliver results from day one.
            </p>
          </div>
        </v-col>
      </v-row>

      <!-- Row 2 -->
      <v-row class="section__row">
        <v-col
          class="section__col order-last order-sm-first info__col"
          cols="12"
          sm="6"
          md="6"
          lg="8"
          xl="8"
        >
          <div class="col__info">
            <p class="section__title-2 dms600">
              Affordable Solutions            </p>
            <p class="section__description-2 m500">
              With Nepal's lower living costs compared to the developed world, we can provide skilled professionals at a more budget-friendly rate, enabling significant cost savings for your company.
            </p>
          </div>
        </v-col>
        <v-col class="section__col">
          <keep-alive>
            <v-img
              eager
              :src="
                require('@/assets/img/affordable-solutions.svg')
              "
              class="section__img"
            ></v-img>
          </keep-alive>
        </v-col>
      </v-row>

      <!-- Row 3 -->
      <v-row class="section__row">
        <v-col class="section__col" cols="12" sm="6" md="6" lg="4" xl="4">
          <keep-alive>
            <v-img
              eager
              :src="
                require('@/assets/img/payroll-compliance.svg')
              "
              class="section__img"
            ></v-img>
          </keep-alive>
        </v-col>
        <v-col
          class="section__col info__col"
          cols="12"
          sm="6"
          md="6"
          lg="8"
          xl="8"
        >
          <div class="col__info">
            <p class="section__title-2 dms600">
              Payroll and Compliance?<br>
              We’ve Got It Covered
            </p>
            <p class="section__description-2 m500">
              With our staff augmentation model, you don’t need to worry about payroll or compliance. DIGU legally employs the professionals, handling all compensation, benefits, and compliance with local labor laws—so you can focus entirely on delivery and growth.
            </p>
          </div>
        </v-col>
      </v-row>

      <!-- Row 4 -->
      <v-row class="section__row">
        <v-col
          class="section__col order-last order-sm-first info__col"
          cols="12"
          sm="6"
          md="6"
          lg="8"
          xl="8"
        >
          <div class="col__info">
            <p class="section__title-2 dms600">Onboard Talent Faster</p>
            <p class="section__description-2 m500">
              Skip the long hiring cycles. With DIGU, you get instant access to 
              pre-vetted professionals who are ready to interview when you are—equipped with strong technical skills, clear communication, and the ability to thrive under pressure.
            </p>
          </div>
        </v-col>
        <v-col class="section__col">
          <keep-alive>
            <v-img
              eager
              :src="require('@/assets/img/onboard-talents.svg')"
              class="section__img"
            ></v-img>
          </keep-alive>
        </v-col>
      </v-row>

      <!-- Row 5 -->
      <v-row class="section__row">
        <v-col class="section__col" cols="12" sm="6" md="6" lg="4" xl="4">
          <keep-alive>
            <v-img
              eager
              :src="require('@/assets/img/round-the-clock.svg')"
              class="section__img"
            ></v-img>
          </keep-alive>
        </v-col>
        <v-col
          class="section__col info__col"
          cols="12"
          sm="6"
          md="6"
          lg="8"
          xl="8"
        >
          <div class="col__info">
            <p class="section__title-2 dms600">Round-the-Clock Availability</p>
            <p class="section__description-2 m500">
              Our highly motivated professionals are available 24/5, catering to both onshore and offshore work hours, according to your project requirements.
            </p>
          </div>
        </v-col>
      </v-row>

      <!-- Row 6 -->
      <v-row class="section__row">
        <v-col
          class="section__col order-last order-sm-first info__col"
          cols="12"
          sm="6"
          md="6"
          lg="8"
          xl="8"
        >
          <div class="col__info">
            <p class="section__title-2 dms600">Flexible Scalability</p>
            <p class="section__description-2 m500">
              Seamlessly scale your technology team with DIGU to meet your company's evolving needs. Our agile approach enables swift workforce adjustments without incurring substantial expenses.
            </p>
          </div>
        </v-col>
        <v-col class="section__col">
          <keep-alive>
            <v-img
              eager
              :src="require('@/assets/img/flexible-scalability.svg')"
              class="section__img"
            ></v-img>
          </keep-alive>
        </v-col>
      </v-row>

      <!-- Row 7 -->
      <v-row class="section__row">
        <v-col class="section__col" cols="12" sm="6" md="6" lg="4" xl="4">
          <keep-alive>
            <v-img
              eager
              :src="require('@/assets/img/accelerate-time.svg')"
              class="section__img"
            ></v-img>
          </keep-alive>
        </v-col>
        <v-col
          class="section__col info__col"
          cols="12"
          sm="6"
          md="6"
          lg="8"
          xl="8"
        >
          <div class="col__info">
            <p class="section__title-2 dms600">Accelerated 
              Time to Market</p>
            <p class="section__description-2 m500">
              Kick off development right away with experienced professionals. Our Nepal-based team extends your workday, enabling faster delivery and helping you reach the market sooner.
            </p>
          </div>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BenefitsSection',
};
</script>

<style scoped>
.section--benefits {
  background-color: #F7F8FC;
  padding-block: 4rem;
}

@media only screen and (min-width: 700px) {
  .section--benefits {
    padding-block: 2rem;
  }
}

.section__header {
  margin-bottom: 3rem;
}

.section__subtitle {
  font-size: 1.25rem;
  color: var(--accent-red);
  text-align: left;
}

@media only screen and (min-width: 1280px) {
  .section__subtitle {
    font-size: 1.5rem;
  }
}

.section__title {
  font-size: 1.25rem;
  text-align: left;
}

@media only screen and (min-width: 1280px) {
  .section__title {
    font-size: 1.75rem;
  }
}

.section__row {
  margin-bottom: 3rem;
}

@media only screen and (min-width: 1280px) {
  .section__row {
    margin-bottom: auto;
  }
}

.section__col {
  display: flex;
  align-items: center;
  justify-content: center;
}

.section__img {
  height: 250px;
  width: 100%;
}

@media only screen and (min-width: 1280px) {
  .section__img {
    width: 100%;
  }
}

.section__title {
  font-size: 1.3rem;
  text-align: left;
}

.col__info {
  text-align: left;
}

@media only screen and (min-width: 1280px) {
  .col__info {
    text-align: left;
    width: 80%;
  }
}

@media only screen and (min-width: 1280px) {
  .info__col:nth-child(odd) {
    justify-content: flex-start;
  }

  .info__col:nth-child(even) {
    justify-content: flex-end;
  }
}

.section__title-2 {
  line-height: 120%;
}

@media only screen and (min-width: 1200px) {
  .section__title-2 {
    margin-bottom: 1rem;
  }
}
</style>
